module.exports = __webpack_public_path__ + "6a66a6549116ade18af4aebd267ae520.jpg";